const BRAND_ASSET_PATH =
  /^(?:\.\/|\/)?(?:media\/logos\/(?:logo_nuts_1|logo_nuts|just_logo_nuts|icone)\.png|favicon\.ico)(?:[?#]|$)/;

export function brandAssetUrl(asset) {
  const version = process.env.VUE_APP_BRAND_ASSET_VERSION;
  if (!version || typeof asset !== "string" || !BRAND_ASSET_PATH.test(asset)) {
    return asset;
  }

  const fragmentIndex = asset.indexOf("#");
  const fragment = fragmentIndex < 0 ? "" : asset.slice(fragmentIndex);
  const url = fragmentIndex < 0 ? asset : asset.slice(0, fragmentIndex);
  const [pathname, search = ""] = url.split("?");
  const params = new URLSearchParams(search);
  params.set("brandv", version);
  return `${pathname}?${params.toString()}${fragment}`;
}
